import Ajv from 'ajv';

import { removeNodeMetadata } from './recipe-utils';

import schema from '../constants/schema.json';

export function validateRecipe(recipe) {
  const ajv = new Ajv();
  const validate = ajv.compile(schema);
  validate(removeNodeMetadata(recipe));

  return validate.errors || [];
}

export function valueAtPathIsValid(path, validationErrors) {
  if (validationErrors.length === 0) {
    return true;
  }
  const formattedErrorPaths = validationErrors.map(({ instancePath }) => {
    return instancePath.split('/').slice(1).join('.');
  });
  return !formattedErrorPaths.some((errorPath) => errorPath === path);
}

export function pathInValidationErrors(path, validationErrors) {
  if (validationErrors.length === 0) {
    return false;
  }
  const formattedErrorPaths = validationErrors.map(({ instancePath }) => {
    return instancePath.split('/').slice(1).join('.');
  });
  return formattedErrorPaths.some((errorPath) => errorPath.includes(path));
}
